module.exports = __webpack_public_path__ + "img/orden_galeria_seleccionado.1e074639.png";